import React from "react";
import rehypeReact from "rehype-react";
import { Twitter, Email } from "../components/social";
import ImageLegend from '../components/image-legend';

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    "social-twitter": Twitter,
    "social-email": Email,
    "image-legend": ImageLegend,
  },
  // components: { "my-component": MyComponent }
}).Compiler;

export default renderAst;
